import { BaseController } from './BaseController';

export default class LanguageController extends BaseController {
  id = 'LanguageController';

  init() {
    this.root = this.getRoot();
    this.root.addEventListener('change', this.triggerLangChange);
  }

  triggerLangChange = () => {
    let url = window.location.origin;
    url += '/';
    url += this.root.options[this.root.selectedIndex].value;
    window.location.href = url;

    return false;
  };
}
